import React from 'react';
import { Typography } from '@mui/material';
import { useContent, useContentContext } from '@qbe/dfc-content';
import { useTrackSummary } from 'hooks/useAnalytics';

const ExpenseModalContent = () => {
  const { getJSXContent } = useContent({
    context: useContentContext(),
  });
  useTrackSummary('expenseModal');

  return <Typography style={{ textAlign: 'left' }}>{getJSXContent('Expense.modal.content')}</Typography>;
};

export default ExpenseModalContent;
